import { useEffect } from 'react';

export function useChallengeResultsRefresh(enabled: boolean, refresh: () => Promise<void>) {
  useEffect(() => {
    if (!enabled) return;
    const update = () => {
      if (document.visibilityState === 'visible') void refresh();
    };
    const timer = window.setInterval(update, 30000);
    window.addEventListener('focus', update);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, [enabled, refresh]);
}
